module.exports = __webpack_public_path__ + "static/media/ditu.4cf78753.png";